import { render } from "./Alumni.vue?vue&type=template&id=4d8a5da9&scoped=true"
import script from "./Alumni.vue?vue&type=script&lang=js"
export * from "./Alumni.vue?vue&type=script&lang=js"

import "./Alumni.vue?vue&type=style&index=0&id=4d8a5da9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8a5da9"]])

export default __exports__